.card {
    /* The tinted rail bleeds to the card edge, so padding lives on the
       regions rather than the Paper, and the corners clip the rail background. */
    overflow: hidden;
    transition:
        box-shadow 150ms ease,
        border-color 150ms ease;
}

.cardLink {
    display: block;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
}

.cardLink:focus-visible {
    outline: 2px solid var(--mt-brand-accent);
    outline-offset: 2px;
}

.card {
    transition:
        box-shadow 150ms ease,
        border-color 150ms ease,
        background-color 150ms ease;
}

.cardLink:hover .card,
.cardLink:focus-visible .card {
    background-color: var(--mt-brand-subtle);
    border-color: var(--mantine-color-brand-4);
    box-shadow: var(--mantine-shadow-sm);
}

.card:has(.cardLink:active) {
    box-shadow: none;
}

.cardLink:focus-visible {
    outline: 2px solid var(--mantine-color-brand-5);
    outline-offset: -2px;
}

.cardBody {
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;

    .projectName {
        font-size: 1.25rem;
        font-weight: 600;
        letter-spacing: -0.01em;
    }
}

.opsRegion {
    flex: 1;
    min-width: 0;
    padding: 16px 18px;
}

.cardFooter {
    padding: 0 18px 12px;
}

/* Pill shared by the status badge and the verdict badge. */
.pill {
    height: 22px;
    padding: 0 10px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.metaLine {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 13px;
    color: #495057;
}

.metaItem {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.metaSeparator {
    color: #ced4da;
    margin-right: 3px;
}

.metaMuted {
    color: #adb5bd;
}

.statusDot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
    background-color: #40c057;
}

.statusDot[data-open='true'] {
    background-color: #228be6;
}

.railDivider {
    align-self: stretch;
    border-color: #e9ecef;
}

.rail {
    flex-shrink: 0;
    width: 268px;
    display: flex;
    align-items: flex-start;
    background-color: var(--rail-bg, #fff);
    padding: 16px 18px;
}

/* The empty rail is a single centred line, no pill and no tint. */
.rail[data-verdict='none'] {
    align-items: center;
}

.railEmpty {
    font-size: 12.5px;
    color: #ced4da;
}

.railContent {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: 'badge' 'amount' 'caption';
    gap: 7px;

    .amount {
        grid-area: amount;
        font-weight: 700;
        font-family: var(--mantine-font-family-monospace);
        font-size: 1.5rem;
        letter-spacing: -0.02em;
        font-variant-numeric: tabular-nums;
    }

    .railCaption {
        grid-area: caption;
        font-size: 0.8rem;
        line-height: 1.35;
        color: #868e96;
    }
}

.railBadge {
    grid-area: badge;
    align-self: flex-start;
}

@media (max-width: 48em) {
    .cardBody {
        flex-wrap: wrap;
    }

    .opsRegion {
        flex-basis: 100%;
        padding: 14px 15px 13px;
    }

    .projectName {
        font-size: 16px;
        line-height: 1.25;
    }

    .metaLine {
        font-size: 12.5px;
        gap: 7px;
        row-gap: 5px;
    }

    /* The phone strip drops billing method to keep the line unwrapped. */
    .metaBilling {
        display: none;
    }

    .railDivider {
        display: none;
    }

    .rail {
        width: 100%;
        align-items: center;
        border-top: 1px solid var(--rail-mobile-border, var(--mantine-color-gray-3));
        padding: 12px 15px;
    }

    .rail[data-verdict='none'] {
        padding: 10px 15px;
    }

    .railContent {
        grid-template-columns: 1fr auto;
        grid-template-areas: 'badge amount' 'caption amount';
        column-gap: 12px;
        row-gap: 5px;
        align-items: center;
    }

    .amount {
        font-size: 22px;
        align-self: center;
    }

    .railCaption {
        font-size: 11.5px;
    }
}
